import { RolesLogic } from 'common/permissions/RolesLogic';
import { IRequest, RequestState } from './request/Request';
import { RequestMachine } from './request/RequestMachine';
import { IUser } from './User';

export class RequestLogic {
  /**
   * Ritorna vero se la richiesta proviene da una domanda con fascicolazione per istanza.
   * In caso di fascicolazione unica/nessuna fascicolazione, ritorna falso.
   * In caso di richiesta nulla, ritornerà falso.
   */
  static isDossierTypeEach(request: IRequest | undefined | null): boolean {
    if (!request) return false;
    return request?.dossierId != null;
  }

  /**
   * Controlla l'accesso dell'utente al dettaglio di una richiesta.
   * **NB**: non controlla l'accesso alla procedure, è necessario usare
   * `ProcedureLogic.allowView()` per controllarlo.
   */
  static allowView(
    request: IRequest,
    user: IUser
  ): { allowed: boolean; message?: string } {
    const userRole = RolesLogic.get(user.role);

    // In caso di accesso solo alle proprie richieste
    if (userRole?.hasPermission('request.read:own')) {
      const allowed = user.citizenId === request.citizenId;
      return {
        allowed,
        message: allowed
          ? 'Non si dispone dei permessi per visualizzare la richiesta. (Codice RA01)'
          : ''
      };
    }

    // Se si dispone del permesso di visualizzazione dettaglio si ha accesso
    if (userRole?.hasPermission('request.read')) {
      return { allowed: true };
    }

    return {
      allowed: false,
      message:
        'Non si dispone dei permessi per visualizzare la richiesta. (Codice RA02)'
    };
  }

  /**
   * Ritorna il nome + cognome dell'autore
   */
  static getAuthorFullName(request: IRequest) {
    return `${request.authorName ?? ''}${
      request.authorFamilyName ? ' ' + request.authorFamilyName : ''
    }`;
  }

  /**
   * Ritorna i punteggi della richiesta
   */
  static getPoints(request: IRequest) {
    const rules =
      request.totalRulesPoints != null ? Number(request.totalRulesPoints) : 0;
    const commission =
      request.totalCommissionPoints != null
        ? Number(request.totalCommissionPoints)
        : 0;
    const total = rules + commission;
    return { rules, commission, total };
  }

  /**
   * Ritorna vero se l'utente può inviare la richiesta.
   */
  static canSend(request: IRequest, user: IUser) {
    return (
      !RequestMachine.to(request, RequestState.Sent) ||
      (user.isTester && !RequestMachine.to(request, RequestState.Tested))
    );
  }
}
